module.exports = __webpack_public_path__ + "img/soy.36c773a7.jpg";